module.exports = __webpack_public_path__ + "img/logo_massons_traffic-icon.b432ea8d.svg";